import { z } from "zod";
/**
 * Exercise Structure Schema for DynamoDB
 *
 * The structure is embedded directly in the exercise document.
 * No separate table or ID - just the content.
 *
 * The body field contains the actual exercise content (JSON format).
 * Different exercise types have different body structures.
 */
// Content types for exercise structures
export const ExerciseContentTypeSchema = z.enum([
    "json",
    "peggy", // Legacy parser format
    "html",
    "markdown",
]);
// Main structure schema (embedded in exercise)
export const ExerciseStructureSchema = z.object({
    body: z.string(),
    description: z.string().nullable().optional(),
    instructions: z.string().nullable().optional(),
    content_type: z.string().max(255).default("json"),
    body_translations: z.record(z.string(), z.string()).optional(),
});
// Structure with translations (for multi-language exercises)
export const ExerciseStructureTranslationSchema = z.object({
    body: z.string(),
    description: z.string().nullable().optional(),
    instructions: z.string().nullable().optional(),
});
// Parsed structure for blanks exercise type
export const BlanksStructureSchema = z.object({
    segments: z.array(z.object({
        type: z.enum(["text", "blank"]),
        content: z.string().optional(),
        answer: z.string().optional(),
        alternatives: z.array(z.string()).optional(),
        hint: z.string().optional(),
    })),
});
// Parsed structure for multiple choice exercise type
export const MultipleChoiceStructureSchema = z.object({
    question: z.string(),
    options: z.array(z.object({
        id: z.string(),
        text: z.string(),
        isCorrect: z.boolean(),
    })),
    allowMultiple: z.boolean().optional(),
});
// Parsed structure for sequence exercise type
export const SequenceStructureSchema = z.object({
    items: z.array(z.object({
        id: z.string(),
        text: z.string(),
        correctPosition: z.number(),
    })),
});
// Parsed structure for matching exercise type
export const MatchingStructureSchema = z.object({
    pairs: z.array(z.object({
        id: z.string(),
        left: z.string(),
        right: z.string(),
    })),
});
